import React from 'react';
import './Loader.css'; // Define your loader styles in Loader.css

function Loader() {
  return (
    <div className="loader-container">
      <div className="loader"></div>
      <p className='Loading1'>Loading...</p>
    </div >
  );
}

export default Loader;
